import { OrganizationCityManagement } from "@/components/organization/OrganizationCityManagement";
import { MapPin } from "lucide-react";

const CitiesPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <MapPin className="h-8 w-8" />
          City Management
        </h1>
        <p className="text-muted-foreground mt-2">
          Manage cities for your organization's flight destinations
        </p>
      </div>

      <OrganizationCityManagement />
    </div>
  );
};

export default CitiesPage;
